import { Component } from '@angular/core';

@Component({
  selector: 'app-building-permit-transfer-portal',
  templateUrl: './building-permit-transfer-portal.component.html',
  standalone: false,
})
export class BuildingPermitTransferPortalComponent {}
